import Vue from "vue";
import Router from "vue-router";
import GeodirMapPrincipal from "./views/GeodirMapPrincipal.vue";
import GeodirMapDelivery from "./views/GeodirMapDelivery";
import GeodirMapDeliveryShao from "./views/GeodirMapDeliveryShao.vue";
import GeodirMapDeliveryPlanetChicken from "./views/GeodirMapDeliveryPlanetChicken.vue";

import GeodirMapClaroSector from "./views/GeodirMapClaroSector";
import GeodirMapLosAndes from "./views/GeodirMapLosAndes"
import GeodirMapOlva from "./views/GeodirMapOlva"

import Oauth2 from "./components/Seguridad/Oauth2.vue";
import Contacto from "./components/contacto/Contacto.vue";
import Map from "./views/Map.vue";
import BuilderOptions from "./components/builder/BuilderOptions.vue";
import SearchGeneral from "./components/searchGeneral/SearchGeneralGeodir.vue";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      component: GeodirMapPrincipal,
      children: [
        {
          path: "/place_id/:placeId",
          name: "placeid",
          component: Map,
         
        },
        {
          path: "/builder/:map",
          component: BuilderOptions,
          name: "buildermap",
        },
        {
          path: "/:tipo/:y/:x/:z",
          name: "map",
          component: Map,
        },
        {
          path: "/:tipo/:value/:z",
          name: "map",
          component: SearchGeneral,
        },
        {
          path: "/:tipo/:nombre/:y/:x/:z/:id",
          name: "place",
          component: SearchGeneral,
        },
        {
          path: "/:tipo/:nombre/:y/:x/:z",
          name: "coordinate",
          component: SearchGeneral,
        },
      ],
    },
    {
      path: "/delivery",
      name: "delivery",
      component: GeodirMapDelivery,
      children: [
        {
          path: "builder/:map",
          component: BuilderOptions,
          name: "buildermapdelivery",
        },
        {
          path: ":tipo/:y/:x/:z",
          name: "mapdelivery",
          component: Map,
        },
        {
          path: ":tipo/:nombre/:y/:x/:z/:id",
          name: "placedelivery",
          component: SearchGeneral,
        },
        {
          path: ":tipo/:nombre/:y/:x/:z",
          name: "coordinatedelivery",
          component: SearchGeneral,
        },
      ],
    },
    {
      path: "/deliveryshao",
      name: "deliveryshao",
      component: GeodirMapDeliveryShao,
      children: [
        {
          path: "builder/:map",
          component: BuilderOptions,
          name: "buildermapdeliveryshao",
        },
        {
          path: ":tipo/:y/:x/:z",
          name: "mapdeliveryshao",
          component: Map,
        },
        {
          path: ":tipo/:nombre/:y/:x/:z/:id",
          name: "placedeliveryshao",
          component: SearchGeneral,
        },
        {
          path: ":tipo/:nombre/:y/:x/:z",
          name: "coordinatedeliveryshao",
          component: SearchGeneral,
        },
      ],
    },
    {
      path: "/deliveryplanetchicken",
      name: "deliveryplanetchicken",
      component: GeodirMapDeliveryPlanetChicken,
      children: [
        {
          path: "builder/:map",
          component: BuilderOptions,
          name: "buildermapdeliveryplanetchicken",
        },
        {
          path: ":tipo/:y/:x/:z",
          name: "mapdeliveryplanetchicken",
          component: Map,
        },
        {
          path: ":tipo/:nombre/:y/:x/:z/:id",
          name: "placedeliveryplanetchicken",
          component: SearchGeneral,
        },
        {
          path: ":tipo/:nombre/:y/:x/:z",
          name: "coordinatedeliveryplanetchicken",
          component: SearchGeneral,
        },
      ],
    },
    {
      path: "/bravo-maps",
      name: "clarosector",
      component: GeodirMapClaroSector,
      children: [
        {
          path: ":tipo/:y/:x/:z",
          name: "mapcontrolclarosector",
          component: Map,
        },
        {
          path: ":tipo/:nombre/:y/:x/:z/:id",
          name: "placecontrolclarosector",
          component: SearchGeneral,
        },
        {
          path: ":tipo/:nombre/:y/:x/:z",
          name: "coordinatecontrolclarosector",
          component: SearchGeneral,
        },
      ],
    },
    {
      path: "/olva",
      name: "olva",
      component: GeodirMapOlva,
      children: [
        {
          path: ":tipo/:y/:x/:z",
          name: "mapcontrolclarosector",
          component: Map,
        },
        {
          path: ":tipo/:nombre/:y/:x/:z/:id",
          name: "placecontrolclarosector",
          component: SearchGeneral,
        },
        {
          path: ":tipo/:nombre/:y/:x/:z",
          name: "coordinatecontrolclarosector",
          component: SearchGeneral,
        },
      ],
    },

    {
      path: "/losandes",
      name: "clarosector",
      component: GeodirMapLosAndes,
      children: [
        {
          path: ":tipo/:y/:x/:z",
          name: "mapcontrollosandes",
          component: Map,
        },
        {
          path: ":tipo/:nombre/:y/:x/:z/:id",
          name: "placecontrollosandes",
          component: SearchGeneral,
        },
        {
          path: ":tipo/:nombre/:y/:x/:z",
          name: "coordinatecontrollosandes",
          component: SearchGeneral,
        },
      ],
    },
    {
      path: "/login/:vertical",
      name: "oauth2-type",
      component: Oauth2,
    },
    {
      path: "/contact",
      name: "contact",
      component: Contacto,
    },
  ],
});
